import React, { Component } from 'react';
import { Layout, Button, Dropdown, Menu, Popconfirm } from 'antd';
import Icon, {
  // MenuUnfoldOutlined,
  // MenuFoldOutlined,
  // BellOutlined,
  // QuestionCircleOutlined,
  UserOutlined,
  CloseOutlined,
  BarsOutlined,
  // MenuUnfoldOutlined,
  // MenuFoldOutlined,
} from '@ant-design/icons';
import { Link, withRouter } from 'react-router-dom';
import DropDownMenu from 'commons/DropDownMenu';
import { Auth } from 'aws-amplify';
import { connect } from 'react-redux';
import {
  logout,
  updateCompanyAccount,
  setPermission,
  setViewType,
} from 'store/actions/loginAction';
import Logo from 'commons/Logo';
import SubMenu from 'antd/lib/menu/SubMenu';
import { SliderMenu } from 'utility/context/Menu';
import Title from 'antd/lib/typography/Title';
import { getConnectedCRMs } from 'store/actions/reportAction';
import demandLogo from 'assets/Images/4amDefault/modules.svg';
import { jwtDecode } from 'jwt-decode';

const { Header, Sider, Content } = Layout;

const HideMenuSvg = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M15.8333 2.5H4.16667C3.24619 2.5 2.5 3.24619 2.5 4.16667V15.8333C2.5 16.7538 3.24619 17.5 4.16667 17.5H15.8333C16.7538 17.5 17.5 16.7538 17.5 15.8333V4.16667C17.5 3.24619 16.7538 2.5 15.8333 2.5Z"
      stroke="#475467"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M7.5 2.5V17.5"
      stroke="#475467"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M13.3333 12.5L10.8333 10L13.3333 7.5"
      stroke="#475467"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
);
class MainLayout extends Component {
  constructor(props) {
    super(props);
    const location = this.props.location.pathname;
    const tieringAccess = {
      home: {
        enable: true,
      },
      revenuePlanning: {
        enable:
          (props?.userPermission?.revenuePlanning &&
            props?.userPermission?.revenuePlanning !== 'hidden') ||
          (props.groups?.[2] === 'admin' &&
            props?.viewType !== 'companyadmin' &&
            props?.viewType !== 'companycontributor')
            ? true
            : false,
      },
      goToMarket: {
        enable:
          (props?.userPermission?.goToMarketIntelligence &&
            props?.userPermission?.goToMarketIntelligence !== 'hidden') ||
          (props.groups?.[2] === 'admin' &&
            props?.viewType !== 'companyadmin' &&
            props?.viewType !== 'companycontributor')
            ? true
            : false,
      },
      salesAndMarking: {
        enable:
          (props?.userPermission?.salesMarketing &&
            props?.userPermission?.salesMarketing !== 'hidden') ||
          (props.groups?.[2] === 'admin' &&
            props?.viewType !== 'companyadmin' &&
            props?.viewType !== 'companycontributor')
            ? true
            : false,
      },
      budgetProgram: {
        enable:
          (props?.userPermission?.budgetCampaign &&
            props?.userPermission?.budgetCampaign !== 'hidden') ||
          (props.groups?.[2] === 'admin' &&
            props?.viewType !== 'companyadmin' &&
            props?.viewType !== 'companycontributor')
            ? true
            : false,
      },
      sdrMethodology: {
        enable:
          (props?.userPermission?.SDRMethodology &&
            props?.userPermission?.SDRMethodology !== 'hidden') ||
          (props.groups?.[2] === 'admin' &&
            props?.viewType !== 'companyadmin' &&
            props?.viewType !== 'companycontributor')
            ? true
            : false,
      },
      dashboards: {
        enable:
          (props?.userPermission?.reporting &&
            props?.userPermission?.reporting !== 'hidden') ||
          (props.groups?.[2] === 'admin' &&
            props?.viewType !== 'companyadmin' &&
            props?.viewType !== 'companycontributor')
            ? true
            : false,
        permission: {
          executive: {
            enable:
              (props?.userPermission?.['reporting.executive'] &&
                props?.userPermission?.['reporting.executive'] !== 'hidden') ||
              (props.groups?.[2] === 'admin' &&
                props?.viewType !== 'companyadmin' &&
                props?.viewType !== 'companycontributor')
                ? true
                : false,
          },
          salesandmarketingleadership: {
            enable:
              (props?.userPermission?.[
                'reporting.salesandmarketingleadership'
              ] &&
                props?.userPermission?.[
                  'reporting.salesandmarketingleadership'
                ] !== 'hidden') ||
              (props.groups?.[2] === 'admin' &&
                (props?.viewType !== 'companyadmin' ||
                  props?.viewType !== 'companycontributor'))
                ? true
                : false,
          },
          analytics: {
            enable:
              (props?.userPermission?.['reporting.analytics'] &&
                props?.userPermission?.['reporting.analytics'] !== 'hidden') ||
              (props.groups?.[2] === 'admin' &&
                props?.viewType !== 'companyadmin' &&
                props?.viewType !== 'companycontributor')
                ? true
                : false,
          },
        },
      },
      coaching: {
        enable:
          (props?.userPermission?.coaching &&
            props?.userPermission?.coaching !== 'hidden') ||
          (props.groups?.[2] === 'admin' &&
            props?.viewType !== 'companyadmin' &&
            props?.viewType !== 'companycontributor')
            ? true
            : false,
      },
    };

    this.state = {
      collapsed: false,
      selectedKey: SliderMenu.filter((menus) => menus.path === location)[0]
        ? SliderMenu.filter((menus) => menus.path === location)[0].key
        : '',
      tieringAccess: tieringAccess,
      settingsMenuOpen: false,
    };
  }
  async getXPUrl() {
    if (localStorage.XPJWT) {
      const decoded = jwtDecode(localStorage.XPJWT);
      const origin = decoded.origin;
      const url = `${origin}/sso?token=${localStorage.XPJWT}`;
      if (url.includes('://')) {
        return url;
      } else {
        return `https://${url}`;
      }
    } else {
      const creds = await Auth.currentSession();
      const token = creds?.idToken?.jwtToken;
      const hostname = window.location.hostname;
      switch (hostname) {
        case 'demandgen.dev.xfactor.io':
          return `https://dev.xfactor.io/api/auth/XDGAuth?token=${token}`;
        case 'demandgen.uat.xfactor.io':
          return `https://uat.xfactor.io/api/auth/XDGAuth?token=${token}`;
        case 'app.4amdemand.com':
          return `https://login.xfactor.io/api/auth/XDGAuth?token=${token}`;
        default:
          return `http://localhost:3000/api/auth/XDGAuth?token=${token}`;
      }
    }
  }
  componentWillMount() {
    this.unlisten = this.props.history.listen((location, action) => {
      var key = SliderMenu.filter((menus) => menus.path === location.pathname);
      try {
        key && key.length > 0
          ? this.handleChangeKey(key[0].key)
          : this.handleChangeKey('');
      } catch (e) {}
    });
    this.props.getConnectedCRMs();

    this.checkVersionUpdate();
  }
  componentDidUpdate() {
    this.checkVersionUpdate();
  }
  checkVersionUpdate() {
    if (window.localStorage?.getItem('version')) {
      if (
        String(window.localStorage?.getItem('version')).toLowerCase() !==
        String(process.env?.REACT_APP_VERSION).toLowerCase()
      ) {
        window.localStorage.clear();
        window.location.reload();
      }
    } else {
      window.localStorage.clear();
      window.location.reload();
    }
  }
  componentWillUnmount() {
    this.unlisten();
  }

  handleCollapsed = () => {
    if (!this.state.collapsed) {
      document.getElementById('site-layout').style.marginLeft = '80px';
      document.getElementById('explorics-sider').style.maxWidth = '80px';
      document.getElementById('explorics-sider').style.minWidth = '80px';
      document.getElementById('explorics-sider').style.width = '80px';
    } else {
      document.getElementById('site-layout').style.marginLeft = '250px';
      document.getElementById('explorics-sider').style.maxWidth = '250px';
      document.getElementById('explorics-sider').style.minWidth = '250px';
      document.getElementById('explorics-sider').style.width = '250px';
    }
    this.setState({
      collapsed: !this.state.collapsed,
    });
  };

  handleSignOut = async () => {
    Auth.signOut()
      .then((data) => {
        this.props.logOut();
      })
      .catch((err) => {
        if (err?.code === 'NotAuthorizedException') {
          localStorage.clear();
        }
        console.log(err);
      });
  };

  handleChangeKey = (key) => {
    this.setState({
      selectedKey: key,
    });
  };

  componentDidMount() {
    this.setState({
      collapsed: false,
    });
  }

  switchAccountSelf = async (account) => {
    const { idToken } = await Auth.currentSession();
    await this.props.setPermission(idToken.payload);
    this.props.setViewType('admin');
    await this.props.updateCompanyAccount({ id: account[0] });
    setTimeout(() => {
      window.location.reload();
    }, 500);
  };



  // handleResponsiveDrawer = () =>{
  //   if(document.getElementById("site-layout")){
  //     if(window.innerWidth <= 768){
  //       this.setState({
  //         collapsed: true,
  //       });
  //       document.getElementById("site-layout").style.marginLeft = "80px";
  //     }else{
  //       this.setState({
  //         collapsed: false,
  //       });
  //       document.getElementById("site-layout").style.marginLeft = "250px"
  //     }
  //   }
  // }

  // componentDidMount() {
  //   window.addEventListener('load', this.handleResponsiveDrawer)
  //   window.addEventListener('resize', this.handleResponsiveDrawer)
  // }

  render() {
    const { collapsed, selectedKey, tieringAccess } = this.state;
    const { groups, selectedCompanyName, admin_groups_self, viewType } =
      this.props;

    console.log("groups", groups);  

    return (
      <div id="explorics-container" className="App">
        <Layout style={{ maxWidth: "100vw", overflowX: "hidden" }}>
          <Sider
            theme="light"
            id="explorics-sider"
            className="explorics-sider"
            trigger={null}
            collapsible
            collapsed={collapsed}
            breakpoint="lg"
            collapsedWidth="0"
            onBreakpoint={(broken) => {}}
            // onCollapse={(Collapsed, type) => {
            //   this.setState({collapsed : Collapsed})
            // }}
            width={280}
            style={{ height: '100vh', position: 'fixed', zIndex: 999 }}
          >
            <div className="explorics-sider-menu">
              <div>
                <a
                  onClick={async () => {
                    const url = await this.getXPUrl();
                    if (!url) {
                      return;
                    }
                    window.location.href = url;
                  }}
                  style={{marginTop:'0 !important'}}
                >
                  <Logo
                    datafromparent={this.state}
                    handleChangeKey={this.handleChangeKey}
                  />
                </a>
                <div style={{borderBottom:'1px solid rgba(208,213,221,1)', paddingTop:"10px", paddingBottom:"10px"}}>
                  <Button
                    id="sider-burger"
                    icon={<HideMenuSvg />}
                    onClick={() => {
                      this.setState((preState) => ({
                        collapsed: !preState.collapsed,
                      }));
                    }}
                    style={{
                      display: 'flex',
                      alignItems: 'center',
                      paddingTop:0,
                      paddingBottom:0,
                      width: '100%',
                      fontSize: '16px',
                      color:"#475467",
                      fontWeight:500,
                      fontSize:'15px'
                    }}
                  >
                    {collapsed ? '' : 'Hide Menu'}
                  </Button>
                </div>

                <div
                  id="demandgeneration-typography"
                  style={{ margin: '20px 0 20px 0',padding:'0 20px 20px 20px', borderBottom: '1px solid rgb(208, 213, 221)' }}
                >
                  <img src={demandLogo} alt="demandgeneration-logo" />
                  <Title level={5} style={{ color: '#646C79' }}>
                    Demand Generation
                  </Title>
                </div>
                <div data-tour="tour__modules">
                  <Menu
                    theme="light"
                    mode="inline"
                    defaultSelectedKeys={selectedKey}
                    className="sidebar-menu"
                    onSelect={(p) => {
                      this.handleChangeKey(p.key);
                    }}
                    selectedKeys={selectedKey}
                  >
                    {' '}
                    {SliderMenu.map((item, index) => {
                      const { key, title, icon, path, isSubMenu } = item;
                      return isSubMenu
                        ? tieringAccess?.[key]?.enable && (
                            <SubMenu
                              key={key}
                              className="subMenuItem"
                              icon={icon}
                              // selectedKeys={selectedKey === key}
                              title={title}
                              onClick={() => this.handleChangeKey(key)}
                            >
                              {item.subMenu.map(
                                (subItem, index) =>
                                  tieringAccess?.[key]?.permission?.[
                                    subItem.key
                                  ]?.enable && (
                                    <Menu.Item key={subItem.key}>
                                      <Link to={`${path}${subItem.path}`}>
                                        {' '}
                                        {subItem.title}
                                      </Link>
                                    </Menu.Item>
                                  )
                              )}
                            </SubMenu>
                          )
                        : tieringAccess?.[key]?.enable && (
                            <Menu.Item
                              key={key}
                              icon={icon}
                              id={key}
                              style={{ paddingLeft: '20px' }}
                            >
                              <Link to={path}>{title}</Link>
                            </Menu.Item>
                          );
                    })}
                  </Menu>
                </div>
              </div>
              {!collapsed && (
                <div>
                  <h2
                    style={{
                      color: '#646C79',
                      fontSize: '18px',
                      textAlign: 'center',
                      fontWeight: '500',
                      userSelect: 'none',
                    }}
                  >
                    Version{' '}
                    {process.env.REACT_APP_VERSION
                      ? process.env.REACT_APP_VERSION
                      : '0.1.0'}
                  </h2>
                  <p
                    style={{
                      fontSize: '16px',
                      color: '#646C79',
                      textAlign: 'center',
                      padding: '0 15px',
                    }}
                  >
                    &copy; {new Date().getFullYear()} XFactor.io copyright all
                    rights reserved.
                  </p>
                </div>
              )}
            </div>
          </Sider>

          <Layout
            id="site-layout"
            className={collapsed ? 'layout' : 'layoutCollapsed'}
          >
            <Header className="site-layout-background" style={{ padding: 0, height:'71px' }}>
              {/* {React.createElement(
                collapsed ? MenuUnfoldOutlined : MenuFoldOutlined,
                {
                  className: "trigger",
                  onClick: () => this.handleCollapsed(!collapsed),
                }
              )} */}

              <div id="header-spread">
                {groups && groups[2] === 'admin' && (
                  <span className="admin-title titleText fw500">Welcome, <span className="secondaryColor">administrator.</span></span>
                )}

                <Button
                  type="text"
                  size="large"
                  disabled={!localStorage.XPJWT}
                  title={
                    !localStorage.XPJWT
                      ? 'Are you a part of the XPlatform?'
                      : 'Click to ask MIKEY'
                  }
                  icon={<Icon component={mikeysvg} />}
                  id="mikeyai-btn"
                  onClick={async () => {
                    const url = await this.getXPUrl();
                    if (!url) {
                      return;
                    }
                    window.location.href = `${url}&redirect=chat`;
                  }}
                  style={{
                    color: '#475467'
                  }}
                >
                  Ask MIKEY anything
                </Button>

                {groups && groups[2] === 'admin' && (
                  <>
                    {selectedCompanyName && (
                      <span
                        className="viewingBox"
                        style={{
                          float: 'right',
                          paddingRight: 0,
                          zIndex: 999,
                          position: 'relative',
                          color:'#475467'
                        }}
                      >
                        <strong className="back-to-admin-link">
                          Viewing as{' '}
                          <strong className="primaryColor">
                            {selectedCompanyName}{' '}
                            <span className="secondaryColor">
                              {viewType === 'companyadmin'
                                ? '(company admin view)'
                                : viewType === 'companycontributor'
                                ? '(company contributor view)'
                                : '(admin view)'}
                            </span>
                          </strong>
                          <Popconfirm
                            className="switchDilog "
                            placement="bottomRight"
                            title={
                              <Title level={5}>
                                Do you want to switch to your profile?
                              </Title>
                            }
                            onConfirm={() =>
                              this.switchAccountSelf(admin_groups_self)
                            }
                            okText="Yes"
                            cancelText="No"
                            icon={''}
                            okType=""
                            okButtonProps={{ size: 'middle', type: 'primary' }}
                            cancelButtonProps={{
                              size: 'large',
                              type: 'secondary',
                            }}
                          >
                            <strong
                              style={{ paddingLeft: 8, color: '#A9A9A9' }}
                            >
                              <CloseOutlined />
                            </strong>
                          </Popconfirm>{' '}
                        </strong>
                      </span>
                    )}
                  </>
                )}

                <Dropdown
                  overlay={
                    <DropDownMenu
                      handleSignOut={this.handleSignOut}
                      path={this.props?.location?.pathname}
                    />
                  }
                  trigger={['click']}
                  // visible={this.props.dashboardTourOpen || this.state.settingsMenuOpen}
                  placement={'bottomLeft'}
                >
                  <Button
                    type="text"
                    size="large"
                    icon={<UserOutlined />}
                    id="settings-menu-trigger-btn"
                    data-tour="tour__settings"
                    onBlur={() => {
                      setTimeout(() => {
                        this.setState({
                          settingsMenuOpen: false,
                        });
                      }, 200);
                    }}
                    onFocus={() => {
                      this.setState({
                        settingsMenuOpen: true,
                      });
                    }}
                    style={{
                      height:'32px',
                      width:'32px',
                      borderRadius:'50%',
                      border:'2px solid #475467',
                      marginLeft:'5px'
                    }}
                  />
                </Dropdown>
              </div>
            </Header>

            <Content
              className="mainLayout"
              style={{
                margin: '24px 20px',
                // minWidth: 400,
              }}
            >
              {this.props.children}
            </Content>
          </Layout>
        </Layout>
      </div>
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  const {
    groups,
    selectedCompanyName,
    admin_groups_self,
    userPermission,
    viewType,
    dashboardTourOpen,
  } = state.loginReducer;
  return {
    prop: state.prop,
    groups,
    selectedCompanyName,
    admin_groups_self,
    userPermission,
    viewType,
    dashboardTourOpen,
  };
};

const mapDispatchToProps = (dispatch, ownProps) => {
  return {
    logOut: () => dispatch(logout()),
    updateCompanyAccount: (account) => dispatch(updateCompanyAccount(account)),
    setPermission: (permission) => dispatch(setPermission(permission)),
    setViewType: (viewType) => dispatch(setViewType(viewType)),
    getConnectedCRMs: () => dispatch(getConnectedCRMs()),
  };
};

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(MainLayout)
);

const mikeysvg = () => (
  <svg
    id="Layer_2"
    data-name="Layer 2"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 602.46 695.66"
  >
    <g id="TWO_COLOR" data-name="TWO COLOR">
      <path
        fill="#fdf5d3"
        d="m301.23,0L0,173.91v347.83l301.23,173.92,301.23-173.92V173.91L301.23,0Z"
      />
      <g>
        <path d="m499.28,231.62c-5.52,7.87-13.78,13.11-23.25,14.77-2.1.37-4.2.55-6.28.55-.44,0-.87-.03-1.31-.05l-10.7,6.3c.81,3.83,1.43,7.34,1.91,10.48l107.85-63.49v-6.07l-4.74-2.74-60.8,35.79c-.78,1.54-1.67,3.03-2.68,4.46Z" />
        <path d="m197.24,159.7c-.17-.38-.33-.76-.48-1.14l-25.13-43.35-8.66,5,26.11,45.04c2.64-1.97,5.36-3.82,8.16-5.55Z" />
        <path d="m138.65,249.8l-99.11-58.34-4.57,2.64v6.27l101.59,59.81c.55-3.17,1.24-6.65,2.09-10.37Z" />
        <polygon points="142.42 435.55 142.11 435.33 34.96 495.88 34.96 501.56 40.04 504.49 144.24 445.61 142.42 435.55" />
        <polygon points="474.78 453.9 563.75 503.72 567.5 501.56 567.5 494.36 478.83 444.71 474.78 453.9" />
        <path d="m306.15,43.21l-4.92-2.84-5.08,2.94v26.08c3.42.13,6.76.57,10,1.27v-27.45Z" />
        <path d="m17,183.73v328.2l284.23,164.1,284.23-164.1V183.73L301.23,19.63,17,183.73Zm560.5,323.6l-134.47,77.64v.12h-.2l-141.59,81.75L24.96,507.33V188.33L301.23,28.82l276.27,159.5v319.01Z" />
        <path d="m415.92,157.12l21.95-37.86-8.66-5-21.13,36.44c2.63,1.98,5.25,4.11,7.84,6.42Z" />
        <rect x="496.53" y="341.86" width="70.96" height="10" />
        <rect x="34.96" y="341.86" width="75.45" height="10" />
        <g>
          <path
            fill="#f48220"
            d="m469.44,466.02l-33.23,6.96c-5.83,13.89-14.61,26.34-25.59,36.52,12.99,6.07,37.13,19.88,61.7,47.01l91.44-52.79-88.97-49.82-5.34,12.12Z"
          />
          <path
            fill="#f48220"
            d="m110.41,334.37h23.95v-34.78c-2.07,1.36-3.94,3.04-5.53,5.03-3.97,4.97-5.78,11.19-5.07,17.51l-9.94,1.1c-1-8.98,1.56-17.81,7.2-24.86,1.96-2.44,4.2-4.57,6.68-6.35-15.62-4.46-27.1-18.85-27.1-35.89h17c0,10.04,7.33,18.39,16.92,20.01.23-3.07.78-8.69,2.04-15.98l-101.59-59.81v141.49h75.45v-7.49Z"
          />
          <path
            fill="#f48220"
            d="m151.04,213.4c9.52-20.29,22.34-36.42,38.04-48.16l-26.11-45.04-123.43,71.26,99.11,58.34c2.47-10.76,6.33-23.49,12.39-36.41Z"
          />
          <path
            fill="#f48220"
            d="m459.65,263.66c1.36,8.79,1.6,14.5,1.63,15.04v.32s0,40.24,0,40.24c1.67,7.72,8.55,13.53,16.77,13.53,9.47,0,17.17-7.7,17.17-17.17s-7.7-17.17-17.17-17.17v-10c14.98,0,27.17,12.19,27.17,27.17,0,7.85-3.35,14.93-8.69,19.9v6.34h70.96v-141.69l-107.85,63.49Z"
          />
          <path
            fill="#f48220"
            d="m455.56,243.97c.84,3.22,1.57,6.31,2.18,9.22l10.7-6.3c-4.44-.16-8.8-1.15-12.88-2.92Z"
          />
          <polygon
            fill="#f48220"
            points="496.53 404.52 478.83 444.71 567.5 494.36 567.5 351.86 496.53 351.86 496.53 404.52"
          />
          <path
            fill="#f48220"
            d="m351.52,125.17c10.78,2.46,25.61,7.02,40.79,15.36,5.12,2.81,10.46,6.18,15.78,10.18l21.13-36.44-123.07-71.05v27.45c25.35,5.52,44.52,27.74,45.38,54.51Z"
          />
          <path
            fill="#f48220"
            d="m193.67,142.74c0-12.3,5.36-23.94,14.72-31.94l11.05,12.92c-5.57,4.77-8.77,11.7-8.77,19.03,0,3.18.6,6.28,1.74,9.19,8.25-3.46,17.05-6,26.37-7.59-1.72-5.46-2.65-11.27-2.65-17.29,0-31.82,25.89-57.72,57.72-57.72.77,0,1.53.03,2.29.06v-26.08l-124.52,71.89,25.13,43.35c-2.03-4.99-3.09-10.34-3.09-15.82Z"
          />
          <path
            fill="#f48220"
            d="m450.96,214.24l.16-.03c.87,5,3.64,9.35,7.79,12.27,4.15,2.92,9.19,4.04,14.19,3.16,10.32-1.81,17.24-11.67,15.43-21.98l16.75-2.93c1.35,7.74.18,15.54-3.32,22.42l60.8-35.79-124.88-72.1-21.95,37.86c14.63,13.02,28.09,31.39,35.03,57.12Z"
          />
          <polygon
            fill="#f48220"
            points="110.41 412.39 110.41 351.86 34.96 351.86 34.96 495.88 142.11 435.33 110.41 412.39"
          />
          <path
            fill="#f48220"
            d="m145.21,451.02l-.98-5.41-104.19,58.88,91.93,53.07,64.68-33.74-1.43-.95c-26.34-15.57-44.56-41.74-50.01-71.86Z"
          />
          <path
            fill="#f48220"
            d="m307.35,128.91v10c-13.76,0-24.95-11.19-24.95-24.95,0-.85.04-1.7.13-2.53-3,4.51-4.76,9.92-4.76,15.74h-8.99c-.15,24.28,13.59,36.1,19.92,40.26,1.69.21,3.4.34,5.15.34v9.84c.65.02,1.31.05,1.97.05,18.56,0,34.82-9.87,43.8-24.66l.51-10.48s.02,0,.03,0c1.41.07,2.8.16,4.19.27,34.96,2.72,63.46,17.69,83.89,43.79-9.61-15.12-23.11-27.53-40.45-37.11-15.61-8.63-31.08-12.99-41.37-15.13-2.39-.5-4.5-.88-6.27-1.17-3.71-.6-5.91-.78-5.98-.79l.41-5.33h-.02c0-1.68-.11-3.32-.31-4.95-2.16-11.96-11.81-21.35-23.91-23.11l-2.97.02c-8.27,0-14.98,6.71-14.98,14.95s6.71,14.95,14.95,14.95Z"
          />
          <path
            fill="#f48220"
            d="m322.55,559.33c-12,4.77-22.82,7.08-33.41,7.08-2.95,0-5.88-.18-8.81-.53-16.39-1.99-32.47-7.97-46.51-17.31l-10.45-6.96c17.85,25,46.85,40.33,78.47,40.33,38.73,0,73.19-23.11,88.34-57.71l-58.4,30.55c-3.24,1.89-6.26,3.38-9.24,4.56Z"
          />
          <polygon
            fill="#f48220"
            points="453.81 376.64 443.13 434.35 451.25 433.43 464.93 400.96 459.53 400.96 459.53 372.04 453.81 376.64"
          />
          <path
            fill="#f48220"
            d="m247.39,340.53c-2.03-13.08-8.05-24.6-16.6-32.93l-4.47,4.37c-7.98-8.15-18.33-12.64-29.15-12.64v-3.5c-22.77,0-41.78,18.13-45.82,42.01v14.41h23.31c.17-18.52,16.96-33.54,37.58-33.54,16.04,0,29.75,9.09,35.14,21.83Z"
          />
          <path
            fill="#f48220"
            d="m360.81,295.82v3.5c-10.82,0-21.18,4.49-29.15,12.64l-3.6-3.53c-10.13,10.33-16.5,25.27-16.5,41.88,0,.98.02.95.07,1.92h.54c0-.36.01-.72.03-1.07.79-18.03,17.33-32.47,37.55-32.47s37.41,15.02,37.58,33.54h20.17l-.05-4.87c0-28.45-20.92-51.54-46.62-51.54Z"
          />
        </g>
      </g>
      <g>
        <g>
          <path
            fill="#2f2e7a"
            d="m184.66,352.24c.16-11.87,10.42-21.67,23.69-23.3-9.6,4.2-16.26,13.05-16.38,23.3,0,.09,0,.18,0,.28h3.74s0,0,0,0h36.27c.05-.09.08-.19.12-.28.74-1.61,1.18-3.33,1.18-5.14,0-3.36-1.41-6.45-3.78-8.97,6.04,2.64,10.2,7.96,10.33,14.11,0,.09.02.18.02.28h10c0-.45-.02-.9-.04-1.35-.16-3.73-1-7.31-2.41-10.64-5.39-12.75-19.11-21.83-35.14-21.83-20.62,0-37.41,15.02-37.58,33.54,0,.09,0,.18,0,.28h10c0-.09,0-.19,0-.28Z"
          />
          <path
            fill="#2f2e7a"
            d="m241.83,452.95c-5.89,3.05-10.63,6.42-13.67,8.8l-9.52-9.54,11.32-11.62-7.16-6.98-18.2,18.68,23.14,23.18,3.54-3.31c.05-.05,1.35-1.24,3.58-2.96.92.89,12.83,12.3,25.72,19.08l1.09.58h39.65l1.09-.58c9.36-4.92,18.2-12.29,22.7-16.3l17.79-.78,20.53-20.73-21.51-21.25-7.03,7.11,14.39,14.22-10.73,10.84-9.73.43c-2.52-3.69-7.04-8.56-14.64-12.01-9.2-4.18-20.32-5.14-33.07-2.87-12.03-3.16-25.58-1.1-39.27,6.01Zm36.04,9.31l-16.63,1.66-4.77-6.29c6.62-2.08,13.98-2.97,21.4-1.19v5.82Zm23.87,1.66l-16.63-1.66v-5.84c8.65-1.25,15.77-.61,21.42,1.18l-4.79,6.32Z"
          />
          <path
            fill="#2f2e7a"
            d="m331.66,311.96c7.98-8.15,18.33-12.64,29.15-12.64v-3.5c25.71,0,46.62,23.1,46.62,51.54l.05,4.87v.06s10-.11,10-.11l-.06-4.87c0-33.9-25.4-61.49-56.62-61.49v-3.5c-15.43,0-30.1,6.31-41.31,17.76l8.55,8.36,3.6,3.53Z"
          />
          <path
            fill="#2f2e7a"
            d="m322.17,352.24c.12-6.15,4.29-11.47,10.33-14.11-2.36,2.52-3.78,5.61-3.78,8.97,0,1.81.43,3.53,1.18,5.14.04.09.08.19.12.28h36.27s0,0,0,0h3.74c0-.09,0-.19,0-.28-.12-10.25-6.78-19.1-16.38-23.3,13.27,1.63,23.53,11.43,23.69,23.3,0,.09,0,.18,0,.28h10c0-.09,0-.19,0-.28-.17-18.52-16.96-33.54-37.58-33.54s-36.76,14.45-37.55,32.47c-.02.35-.03.71-.03,1.07,0,.09,0,.18,0,.28h10c0-.09.01-.18.02-.28Z"
          />
          <path
            fill="#2f2e7a"
            d="m282.89,500.82c-12.62,0-24.42-3.59-33.24-10.12l-5.95,8.04c10.53,7.79,24.44,12.08,39.19,12.08s28.84-4.35,39.4-12.24l-5.99-8.01c-8.84,6.61-20.7,10.25-33.41,10.25Z"
          />
          <path
            fill="#2f2e7a"
            d="m301.23,0L0,173.91v347.83l301.23,173.92,301.23-173.92V173.91L301.23,0Zm284.23,511.93l-284.23,164.1L17,511.93V183.73L301.23,19.63l284.23,164.1v328.2Z"
          />
          <path
            fill="#2f2e7a"
            d="m24.96,188.33v319.01l276.27,159.5,141.59-81.75h.2v-.12l134.47-77.64V188.33L301.23,28.82,24.96,188.33Zm10,307.55V194.1l4.57-2.64,123.43-71.26,8.66-5,124.52-71.89,5.08-2.94,4.92,2.84,123.07,71.05,8.66,5,124.88,72.1,4.74,2.74v307.46l-3.74,2.16-91.44,52.79c-24.57-27.14-48.7-40.94-61.7-47.01,10.98-10.17,19.76-22.62,25.59-36.52l33.23-6.96,5.34-12.12,4.05-9.19,17.7-40.19v-69c5.34-4.96,8.69-12.04,8.69-19.9,0-14.98-12.19-27.17-27.17-27.17v10c9.47,0,17.17,7.7,17.17,17.17s-7.7,17.17-17.17,17.17c-8.22,0-15.1-5.81-16.77-13.53v-40.56c-.03-.55-.27-6.25-1.63-15.04-.48-3.13-1.11-6.65-1.91-10.48-.61-2.91-1.34-6-2.18-9.22,4.08,1.77,8.43,2.76,12.88,2.92.44.02.87.05,1.31.05,2.08,0,4.19-.18,6.28-.55,9.47-1.66,17.73-6.9,23.25-14.77,1.01-1.44,1.9-2.93,2.68-4.46,3.49-6.89,4.67-14.68,3.32-22.42l-16.75,2.93c1.81,10.31-5.12,20.17-15.43,21.98-4.99.87-10.03-.25-14.19-3.16-4.15-2.91-6.92-7.27-7.79-12.27l-.16.03c-6.95-25.72-20.4-44.1-35.03-57.12-2.59-2.3-5.21-4.44-7.84-6.42-5.31-4-10.65-7.36-15.78-10.18-15.18-8.34-30-12.9-40.79-15.36-.86-26.77-20.03-48.99-45.38-54.51-3.24-.71-6.58-1.14-10-1.27-.76-.03-1.52-.06-2.29-.06-31.82,0-57.72,25.89-57.72,57.72,0,6.02.93,11.83,2.65,17.29-9.32,1.59-18.12,4.13-26.37,7.59-1.15-2.9-1.74-6.01-1.74-9.19,0-7.32,3.2-14.26,8.77-19.03l-11.05-12.92c-9.35,8-14.72,19.65-14.72,31.94,0,5.48,1.06,10.83,3.09,15.82.16.38.31.76.48,1.14-2.8,1.72-5.52,3.57-8.16,5.55-15.7,11.74-28.51,27.87-38.04,48.16-6.06,12.91-9.93,25.65-12.39,36.41-.85,3.72-1.54,7.2-2.09,10.37-1.26,7.29-1.81,12.92-2.04,15.98-9.59-1.62-16.92-9.97-16.92-20.01h-17c0,17.03,11.48,31.43,27.1,35.89-2.47,1.78-4.72,3.9-6.68,6.35-5.64,7.05-8.2,15.88-7.2,24.86l9.94-1.1c-.7-6.32,1.1-12.54,5.07-17.51,1.59-1.99,3.47-3.67,5.54-5.03v34.78h-23.95v78.02l31.7,22.93.3.22,1.82,10.07.98,5.41c5.45,30.11,23.67,56.29,50.01,71.86l1.43.95-64.68,33.74-91.93-53.07-5.08-2.93v-5.68Zm92.45-92.17v-52.34h6.94v34.06s17,0,17,0v-47.61c4.04-23.88,23.04-42.01,45.82-42.01v3.5c10.82,0,21.18,4.49,29.15,12.64l4.47-4.37,7.69-7.52c-11.2-11.45-25.87-17.76-41.31-17.76v3.5c-7.53,0-14.72,1.62-21.29,4.53v-15.21c.08-1.59,1.4-25.59,11.83-51.76,12.29-30.82,31.57-51.9,57.39-62.84.55-.08,1.1-.14,1.65-.2,10.46,14.76,27.67,24.43,47.1,24.43v-17c-1.75,0-3.46-.12-5.15-.34-20.03-2.54-35.57-19.67-35.57-40.38,0-22.45,18.27-40.72,40.72-40.72,4.82,0,9.45.85,13.75,2.4-.45-.02-.91-.03-1.36-.03-21.22,0-38.48,17.26-38.48,38.48h10c0-5.82,1.76-11.23,4.76-15.74-.08.83-.13,1.68-.13,2.53,0,13.76,11.19,24.95,24.95,24.95v-10c-8.25,0-14.95-6.71-14.95-14.95s6.71-14.95,14.98-14.95l2.97-.02c12.1,1.75,21.75,11.14,23.91,23.11.2,1.62.31,3.27.31,4.95h.02l-.41,5.33c.07,0,2.27.19,5.98.79,1.76.29,3.88.67,6.27,1.17,10.29,2.15,25.76,6.51,41.37,15.13,17.34,9.59,30.84,22,40.45,37.11-20.44-26.1-48.93-41.07-83.89-43.79-1.39-.11-2.78-.2-4.19-.27,0,0-.02,0-.03,0l-.51,10.48-.32,6.5c41.4,2.03,71.58,22.44,89.69,60.67,13.48,28.44,15.18,56.91,15.29,59.05v72.08h7.17v.08h17.79l-24.59,19.8-11.42,61.68,9.83,1.82.06-.33,10.69-57.71,5.71-4.6v28.92h10v-36.97l10.01-8.06v45.02l-22.13,50.23-33.78,7.07-1.62,4.43c-6.99,19.06-20.46,35.24-37.94,45.57l-60.33,31.55-.36.2c-2.56,1.5-4.88,2.65-7.1,3.54-12.77,5.07-23.23,6.76-33.9,5.46-13.77-1.67-27.3-6.71-39.13-14.58l-38.8-25.82-.4-.25c-22.18-13.04-37.52-35.04-42.1-60.35l-4.02-22.21-30.51-22.07Zm50.9-183.75c-11.31,28.51-12.39,53.81-12.43,54.87v21.26c-5.63,4.07-10.55,9.21-14.53,15.14v-32.03c.11-2.17,1.73-30.18,15.07-58.59,10.47-22.3,25.02-38.56,43.47-48.72-13.21,12.44-23.87,28.58-31.59,48.06Zm55.52,328.6c14.03,9.34,30.11,15.32,46.51,17.31,2.93.35,5.86.53,8.81.53,10.58,0,21.41-2.31,33.41-7.08,2.98-1.18,6-2.68,9.24-4.56l58.4-30.55c-15.15,34.6-49.61,57.71-88.34,57.71-31.62,0-60.62-15.32-78.47-40.33l10.45,6.96Zm-54.19,36.52h27.92v-10h-45.24l-12.9-7.45,59.15-30.85c18.57,33.82,54.09,55.15,93.28,55.15,44.35,0,83.62-27.46,99.29-68.05,10.1,4.49,32.73,16.41,56.1,41.33l-17.09,9.87h-46.52v10h29.2l-121.59,70.2-121.59-70.2Z"
          />
        </g>
        <polygon
          fill="#2f2e7a"
          points="248.74 386.3 229.53 405.5 248.45 423.8 253.86 418.12 262.73 427.14 275.96 413.97 260.06 397.81 248.88 408.93 243.84 404.07 255.15 392.77 248.74 386.3"
        />
        <polygon
          fill="#2f2e7a"
          points="308.68 413.64 295.55 400.54 282.4 413.79 295.53 426.9 308.68 413.64"
        />
        <polygon
          fill="#2f2e7a"
          points="424.15 333.48 411.01 320.37 397.86 333.63 411 346.73 424.15 333.48"
        />
        <polygon
          fill="#2f2e7a"
          points="169.97 333.48 156.84 320.37 143.69 333.63 156.82 346.73 169.97 333.48"
        />
        <path
          fill="#2f2e7a"
          d="m295.6,349.67c-3.04-4.67-8.18-7.46-13.74-7.46s-10.53,2.7-13.58,7.23l-9.94-6.72c5.29-7.83,14.09-12.51,23.53-12.51s18.53,4.83,23.8,12.91l-10.06,6.55Z"
        />
        <path
          fill="#2f2e7a"
          d="m212.35,411.99c-31.58,0-57.27-25.69-57.27-57.27s25.69-57.27,57.27-57.27,57.27,25.69,57.27,57.27-25.69,57.27-57.27,57.27Zm0-102.54c-24.96,0-45.27,20.31-45.27,45.27s20.31,45.27,45.27,45.27,45.27-20.31,45.27-45.27-20.31-45.27-45.27-45.27Z"
        />
        <path
          fill="#2f2e7a"
          d="m351.58,411.99c-31.58,0-57.27-25.69-57.27-57.27s25.69-57.27,57.27-57.27,57.27,25.69,57.27,57.27-25.69,57.27-57.27,57.27Zm0-102.54c-24.96,0-45.27,20.31-45.27,45.27s20.31,45.27,45.27,45.27,45.27-20.31,45.27-45.27-20.31-45.27-45.27-45.27Z"
        />
      </g>
    </g>
  </svg>
);
